//
//
//
//
//
//
//

import api from "@/api"
export default {
    name: 'App',
    data () {
        return {
            pcOMobile:'',
            isRouterAlive:true,
        }
    },
    created() {
         if (this._isMobile()) { //手机端
            this.pcOMobile = 'mobilePage'
        } else { //pc
            this.pcOMobile = 'pcPage'
        }
    },
    mounted() {
    },
    methods: {
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
    },
    watch:{   //监听路由变化
        $route( to , from ){
            window.scrollTo(0,0)
            // if (to.name == 'CourseDetail' || to.name == 'CourseList' || to.name == 'OnlineTest' || to.name == 'ChoiceCourse') {
                this.isRouterAlive = false
                this.$nextTick(() => (this.isRouterAlive = true)) 
            // }
        }
    }
}



// WEBPACK FOOTER //
// ./src/App.vue